import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { isMobile } from "react-device-detect";
import Spacebox from "../components/Spacebox";
import Grid from "../components/Grid";

const Privacy = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    const terms_info = [
        {
            image: '/svgs/security.svg',
            heading: 'Data Protection',
            content: 'Industry-standard security measures to protect your sensitive information.'
        },
        {
            image: '/svgs/lock.svg',
            heading: 'Information Security',
            content: `Terms regarding service duration and renewal conditions.`
        },
        {
            image: '/svgs/reg-check.svg',
            heading: 'Compliance',
            content: `Adherence to data protection standards and regulatory requirements.`
        },
        {
            image: '/svgs/eye.svg',
            heading: 'Transparency',
            content: `Clear communication about how your data is collected and used.`
        },
        {
            image: '/svgs/database.svg',
            heading: 'Data Storage',
            content: `Secure storage systems with regular backups to protect your information.`
        },
        {
            image: '/svgs/bell.svg',
            heading: 'Privacy Controls',
            content: `Options to manage your data and communication preferences.`
        },

    ]

    const terms_lists = [
        {
            heading: 'Information We Collect',
            sub: 'We collect information that you provide directly to us, including:',
            lists: [
                'Contact information (name, email, phone number)',
                'Business details and financial information',
                'Communication preferences and history',
                'Service usage data and interactions'
            ]
        },
        {
            heading: 'How We Use Your Information',
            sub: 'Your information is used to:',
            lists: [
                'Provide and improve our funding services',
                'Process your applications and requests',
                'Communicate about services and updates',
                'Comply with legal obligations'
            ]
        },
        {
            heading: 'Data Security',
            sub: `We implement robust security measures to protect your information from unauthorized access, disclosure, alteration, and destruction. Our security practices include:`,
            lists: [
                'Encryption of sensitive data',
                'Regular security audits',
                'Access controls and monitoring',
                'Secure data storage and transmission'
            ]
        },
        {
            heading: 'Your Rights',
            sub: 'You have the right to:',
            lists: [
                'Access your personal information',
                'Request corrections to your data',
                'Delete your account and data',
                'Opt-out of marketing communications'
            ]
        },
    ]



    return (
        <div className="about-page">
            <Header />
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Flexbox justifyContent="center" alignItems="center">
                            <Flexbox alignItems="center" justifyContent="center" style={{ width: '30px', height: 30, padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '100px' }}>
                                <img src="/svgs/security.svg" alt="file" />
                            </Flexbox>
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '40px' : '60px', color: 'var(--primary)' }}>
                            Privacy Policy
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ textAlign: 'center', color: '#00000060', fontSize: isMobile ? '18px' : '20px' }}>
                            At BrightStarr, protecting your privacy and securing your data are fundamental to our business operations.
                        </Typography>
                        <Spacebox padding="10px" />
                        <Grid grid={isMobile ? 1 : 3} gap="20px">
                            {terms_info.map((a, i) => (
                                <div key={i} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                    <Flexbox alignItems="center" justifyContent="center" style={{ display: 'inline-block', padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '5px' }}>
                                        <img src={a.image} alt={a.heading} style={{ width: '30px' }} />
                                    </Flexbox>
                                    <Spacebox padding="10px" />
                                    <Typography>
                                        <b>
                                            {a.heading}
                                        </b>
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <span className="content" style={{ opacity: .6 }}>
                                        {a.content}
                                    </span>
                                </div>
                            ))}
                        </Grid>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
            <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Spacebox padding="10px" />
                        <Container>
                            <Typography variant="h4" style={{ fontSize: isMobile ? '25px' : '30px' }}>
                                Our Commitment to Privacy
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, fontSize: '18px' }}>
                                We take your privacy seriously and are committed to protecting your personal information. This privacy policy explains how we collect, use, and safeguard your data when you use our services.
                            </Typography>
                            <Spacebox padding="20px" />
                            {terms_lists.map((list, i) => (
                                <div key={i} style={{ marginBottom: '20px' }}>
                                    <Typography style={{ fontSize: '18px', fontWeight: '700' }}>
                                        {list.heading}
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <span style={{ opacity: .6 }}>
                                        {list.sub}
                                    </span>
                                    <ul>
                                        {list.lists.map((l, x) => (
                                            <li key={x} style={{ opacity: .6 }}>
                                                {l}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            <Spacebox padding="20px" />
                            <div style={{ borderRadius: '10px', background: '#4A3FFF20', padding: '30px 10px' }}>
                                <small style={{ opacity: .6 }}>
                                    Last updated: {((new Date(Date.now())).toString().substring(4, 16))}
                                </small>
                            </div>
                        </Container>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default Privacy;